import { get } from '@/api/config'

export default {
  config: null,

  // 加载配置
  async load() {
    if(this.config) return
    
    this.config = await get()
    
    return new Promise(resolve => {
      resolve(true)
    })
  },

  get(name) {
    return name ? this.config[name] : this.config
  }
}